export class SysMenus {
    constructor(){
        this.IsHome = false;
        this.IsMainMenu = false;
        this.Component = "";
    }
    /**
     * 组件名称
     */
    Component: string;
    /**
     * 菜单图标
     */
    Icon: string;
    /**
     * 页面对应的ConfigName名称
     */
    PageName: string;
    /**
     * 排序
     */
    SortLevel: number;
    /**
     * 菜单名称
     */
    Title: string;
    /**
     * 路由地址
     */
    Url: string;
    /**
     * 是否为首页
     */
    IsHome: boolean;
    /**
     * 是否主菜单
     */
    IsMainMenu: boolean;
    /**
     * 菜单列表
     */
    menus: Array<SysMenus> = new Array<SysMenus>();
}